export function isProviderVisibleAtLocations(
  visibleLocationIds: readonly string[] | undefined,
  selectedLocationIds: ReadonlySet<string>,
): boolean {
  if (selectedLocationIds.size === 0 || !visibleLocationIds?.length) {
    return true;
  }

  return visibleLocationIds.some((id) => selectedLocationIds.has(id));
}

/** One location; no location means no filter. */
export function isProviderVisibleAtLocation(
  visibleLocationIds: readonly string[] | undefined,
  locationId: string | null | undefined,
): boolean {
  return isProviderVisibleAtLocations(
    visibleLocationIds,
    new Set(locationId ? [locationId] : []),
  );
}
